
            const data = {"name":"active","data":{"width":"25","height":"27","viewBox":"0 0 25 27","data":"<ellipse pid=\"0\" cx=\"12.343\" cy=\"13.535\" rx=\"12.343\" ry=\"12.834\" _fill=\"#2B9E7C\"/><path pid=\"1\" d=\"m6.496 12.184 4.548 4.728 7.795-8.105\" _stroke=\"#fff\" stroke-width=\"2\"/>","originalColors":[{"type":"fill","color":"#2B9E7C"},{"type":"stroke","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    